import React from 'react';

export function Linkedin(props: React.SVGAttributes<{}>) {
    return (
        <svg width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
            <g clipPath="url(#clip0_718_1445)">
                <path d="M13 26C20.1797 26 26 20.1797 26 13C26 5.8203 20.1797 0 13 0C5.8203 0 0 5.8203 0 13C0 20.1797 5.8203 26 13 26Z" fill="white" />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M13 26C5.82029 26 0 20.1797 0 13C0 5.82029 5.82029 0 13 0C20.1797 0 26 5.82029 26 13C26 20.1797 20.1797 26 13 26ZM6.86679 19.8551H9.90661V10.292H6.86679V19.8551ZM8.38632 6.19531C7.51283 6.19531 6.80469 6.90508 6.80469 7.7806C6.80469 8.65617 7.51283 9.36594 8.38632 9.36594C9.25981 9.36594 9.96795 8.65617 9.96795 7.7806C9.96795 6.90508 9.25981 6.19531 8.38632 6.19531ZM20.9128 12.604C20.8928 12.2824 19.9746 10.0849 17.873 10.0818C15.8311 10.0789 14.6236 11.3429 14.6236 11.3429V10.3971H11.8385L11.7934 19.75H14.8332C14.8332 19.75 14.8471 14.0465 14.8332 13.865C14.8131 13.6037 15.3104 12.7844 16.4055 12.8141C17.5006 12.8438 17.9778 13.5791 17.9778 13.7599C17.9778 13.9408 17.9778 19.8551 17.9778 19.8551H20.9128C20.9128 19.8551 20.9329 12.9256 20.9128 12.604Z"
                    fill="#0177B5"
                />
            </g>
            <defs>
                <clipPath id="clip0_718_1445">
                    <rect width="26" height="26" fill="white" />
                </clipPath>
            </defs>
        </svg>
    );
}